<vx-sidebar [collapsed]="collapsed()">
  <vx-sidebar-header [compact]="collapsed()">
    <img
      vxSidebarBrand
      class="ms-3 h-6"
      src="/assets/images/logos/incidite-head-white.svg"
      alt="Incidite" />
    <vx-icon-button
      icon="sidebar-simple"
      variant="ghost"
      tone="secondary"
      [ariaLabel]="
        (collapsed()
          ? 'components.sidebar.expand'
          : 'components.sidebar.collapse'
        ) | transloco
      "
      (click)="toggleCollapsed()" />
  </vx-sidebar-header>

  <vx-sidebar-nav>
    <vx-sidebar-nav-group>
      @for (entry of mainNavEntries; track entry.link) {
        <vx-sidebar-nav-item
          [link]="entry.link"
          [icon]="entry.icon"
          [badge]="entry.badge"
          [compact]="collapsed()">
          {{ entry.label | transloco }}
        </vx-sidebar-nav-item>
      }
    </vx-sidebar-nav-group>
    <vx-sidebar-nav-group>
      <vx-sidebar-nav-item
        [href]="supportUrl"
        icon="question"
        [compact]="collapsed()">
        {{ 'components.sidebar.support' | transloco }}
      </vx-sidebar-nav-item>
      @for (entry of settingsNavEntries; track entry.link) {
        <vx-sidebar-nav-item
          [link]="entry.link"
          [icon]="entry.icon"
          [compact]="collapsed()">
          {{ entry.label | transloco }}
        </vx-sidebar-nav-item>
      }
    </vx-sidebar-nav-group>
  </vx-sidebar-nav>

  <vx-sidebar-footer>
    @if (!collapsed() && subscription().data; as sub) {
      @if (sub.paymentActionRequired) {
        <div
          class="rounded-lg bg-zinc-900 p-3"
          [vRequiredRoles]="['subscriptions.manager']">
          <h4 class="text-sm font-medium text-zinc-100">
            {{ 'components.sidebar.paymentRequired.header' | transloco }}
          </h4>
          <p class="mt-1 text-xs text-zinc-400">
            {{ 'components.sidebar.paymentRequired.description' | transloco }}
          </p>
          <vx-button
            class="mt-3"
            size="sm"
            tone="danger"
            [fullWidth]="true"
            (click)="goToSubscriptionSettings()">
            {{ 'components.sidebar.paymentRequired.actionBtn' | transloco }}
          </vx-button>
        </div>
      }
      @if (sub.canStartTrial) {
        <div
          class="rounded-lg bg-zinc-900 p-3"
          [vRequiredRoles]="['subscriptions.manager']">
          <h4 class="text-sm font-medium text-zinc-100">
            {{ 'components.sidebar.startTrialNotification.header' | transloco }}
          </h4>
          <p class="mt-1 text-xs text-zinc-400">
            {{
              'components.sidebar.startTrialNotification.description'
                | transloco
            }}
          </p>
          <vx-button
            class="mt-3"
            size="sm"
            tone="primary"
            [fullWidth]="true"
            (click)="goToSubscriptionSettings()">
            {{
              'components.sidebar.startTrialNotification.trialBtn' | transloco
            }}
          </vx-button>
        </div>
      }
      @if (sub.status === SubscriptionStatus.TRIALING) {
        <div
          class="rounded-lg bg-zinc-900 p-3"
          [vRequiredRoles]="['subscriptions.manager']">
          <h4 class="text-sm font-medium text-zinc-100">
            {{ 'components.sidebar.trialing.header' | transloco }}
          </h4>
          <p class="mt-1 text-xs text-zinc-400">
            {{ 'components.sidebar.trialing.description' | transloco }}
          </p>
          <vx-button
            class="mt-3"
            size="sm"
            tone="primary"
            [fullWidth]="true"
            (click)="goToSubscriptionSettings()">
            {{ 'components.sidebar.trialing.trialBtn' | transloco }}
          </vx-button>
        </div>
      }
    }
    <app-toast-snooze-indicator [compact]="collapsed()" />
    @if (user(); as user) {
      <vx-org-switcher
        [compact]="collapsed()"
        [userName]="userName()"
        [userEmail]="user.email"
        [avatarSrc]="user.avatar"
        [orgs]="orgs()"
        [activeOrgId]="currentOrgId()"
        (accountSelected)="goToAccountSettings()"
        (orgSelected)="selectOrganization($event)">
        <vx-menu-item icon="question" (triggered)="openSupport()">
          {{ 'components.sidebar.support' | transloco }}
        </vx-menu-item>
        <vx-menu-item icon="sign-out" (triggered)="logout()">
          {{ 'actions.logout' | transloco }}
        </vx-menu-item>
      </vx-org-switcher>
    }
  </vx-sidebar-footer>
</vx-sidebar>
